/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Divisionurl3Inputs */

const de__field_divisionurl3 = /** @type {(inputs: _Field_Divisionurl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kooperationspartnereinheit URL`)
};

/**

* @param {_Field_Divisionurl3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_divisionurl3 = /** @type {((inputs?: _Field_Divisionurl3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Divisionurl3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_divisionurl3(inputs)
});
export { _field_divisionurl3 as "_field_divisionURL" }